export default __webpack_public_path__ + "static/media/Africa.7128d2df.svg";